import React from "react";

interface LockIconProps {
  onUnlock: () => void;
}

const LockIcon: React.FC<LockIconProps> = ({ onUnlock }) => {
  return (
    <button
      type="button"
      onClick={onUnlock}
      className="tw-absolute tw-right-3 tw-top-1/2 tw-transform -tw-translate-y-1/2 tw-text-gray-500 hover:tw-text-gray-700"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="tw-h-5 tw-w-5"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
      </svg>
    </button>
  );
};

export default LockIcon;
